export default __webpack_public_path__ + "static/media/hematologia.791f9320.png";